import {Directive, EventEmitter, HostBinding, HostListener, Output} from '@angular/core';

@Directive({
    selector: '[appDnd]',
    standalone: false
})
export class DndDirective {

  @Output() onFileDropped = new EventEmitter<any>();
  @HostBinding('class.fileover') fileOver: boolean;


  // Dragover Listener
  @HostListener('dragover', ['$event']) onDragOver(e){
    e.preventDefault();
    e.stopPropagation();
    this.fileOver = true;
  }

  @HostListener('dragleave', ['$event']) onDragLeave(e){
    e.preventDefault();
    e.stopPropagation();
    this.fileOver = false;
  }

  @HostListener('drop', ['$event']) onDrop(e){
    e.preventDefault();
    e.stopPropagation();
    this.fileOver = false;
    let files = e.dataTransfer.files;
    if (files.length > 0) {
      this.onFileDropped.emit(files)
    }

  }

  constructor() { }

}
